import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { SimpleGrid, Stack, Text } from '@mantine/core';
import { VipClubWorkCard } from './VipClubWorkCard';
export const VipClubWork: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack py={40}>
      <Text fz={{
      base: 'sm',
      sm: 'xl'
    }} className={gunterzBold.className} c="var(--text-white)" ta="center">
        {i18n._('How It Works')}
      </Text>

      <SimpleGrid cols={{
      base: 1,
      sm: 3
    }} spacing={{
      base: 40,
      sm: 20
    }} mt={40}>
        <VipClubWorkCard imgUrl="/assets/vip-club/card.png" title={i18n._('Play Games, Earn XP')} description={i18n._('Every $1 you wager gets you 1 XP. The more you play, the faster you rank up!')} />

        <VipClubWorkCard imgUrl="/assets/vip-club/reward.png" title={i18n._('Climb the Ranks')} description={i18n._('From Bronze to the ultimate Crown Jewel status, each rank unlocks bigger rewards and more features.')} />

        <VipClubWorkCard imgUrl="/assets/vip-club/coin.png" title={i18n._('Claim Your Rewards')} description={i18n._('Enjoy perks like rakeback, daily bonuses, rank-up bonuses, and more.')} />
      </SimpleGrid>
    </Stack>;
};